import { DateUtilities } from "@shared/utilities/date-utilities.model";

export class OrderDriver {
	txt_driver_name: string;
    txt_driver_surname: string;
    txt_fiscal_code_driver: string;
    txt_society_name: string;
    txt_driver_city: string;
    txt_driver_zip_code: string;
    txt_driver_address: string;
    txt_driver_phone: string;
    txt_driver_email: string;
    txt_driver_license_number: string;
    txt_driver_license_by: string;
    ordercardelivery_date_license_release_textbox: string;
    ordercardelivery_date_license_validity_textbox: string;
    txt_driver_gender: string;
    date_driver_birth: string;
    txt_driver_birthplace: string;
    txt_driver_address_number: string;
    txt_driver_license_issue_country: string;
    txt_driver_prefix_phone: string;

    constructor(model?: any) {
		if (model) {
            this.txt_driver_name = model.txt_driver_name;
            this.txt_driver_surname = model.txt_driver_surname;
            this.txt_fiscal_code_driver = model.txt_fiscal_code_driver;
            this.txt_society_name = model.txt_society_name;
            this.txt_driver_city = model.txt_driver_city;
            this.txt_driver_zip_code = model.txt_driver_zip_code;
            this.txt_driver_address = model.txt_driver_address;
            this.txt_driver_phone = model.txt_driver_phone;
            this.txt_driver_email = model.txt_driver_email;
            this.txt_driver_license_number = model.txt_driver_license_number;
            this.txt_driver_license_by = model.txt_driver_license_by;
            this.ordercardelivery_date_license_release_textbox = DateUtilities.getDateWithoutTimes(model.ordercardelivery_date_license_release_textbox);
            this.ordercardelivery_date_license_validity_textbox = DateUtilities.getDateWithoutTimes(model.ordercardelivery_date_license_validity_textbox);
            this.txt_driver_gender = model.txt_driver_gender;
            this.date_driver_birth = DateUtilities.getDateWithoutTimes(model.date_driver_birth);
            this.txt_driver_birthplace = model.txt_driver_birthplace;
            this.txt_driver_address_number = model.txt_driver_address_number;
            this.txt_driver_license_issue_country = model.txt_driver_license_issue_country;
            this.txt_driver_prefix_phone = model.txt_driver_prefix_phone;
        }
    }
}